import * as React from 'react';
type Props = {
  className?: string;
};
export function Sweets2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Sweets2"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6571 109.554C3.41342 95.8928 -9.19428 41.2463 17.0396 38.5059C43.2734 35.7642 57.2967 -8.84814 88.2471 5.95028C119.199 20.7487 119.196 65.1487 108.878 83.365C98.5615 101.581 69.9008 123.214 36.6571 109.554Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6571 109.554C3.41342 95.8928 -9.19428 41.2463 17.0396 38.5059C43.2734 35.7642 57.2967 -8.84814 88.2471 5.95028C119.199 20.7487 119.196 65.1487 108.878 83.365C98.5615 101.581 69.9008 123.214 36.6571 109.554Z"
        fill="#C5D9E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.0677 32.7641C74.4947 34.9992 74.5406 37.3659 74.6331 39.9608C74.6968 41.7674 75.3987 43.1649 76.299 44.6979C77.4972 46.739 77.144 48.8852 77.332 51.1799C77.4853 53.0518 78.2094 56.8553 81.605 56.1328C86.0798 55.1838 85.1495 53.3193 96.9955 50.7284C99.0361 50.2811 102.032 50.5385 103.675 48.7843C105.085 47.2817 106.236 45.84 107.069 43.2315C107.559 41.6978 107.434 39.9403 107.015 38.7862C106.401 37.098 105.035 35.7448 104.254 34.1253C103.463 32.4822 103.955 30.8126 103.89 29.0329C103.81 26.7998 102.055 25.2054 100.854 23.3898C99.4315 21.2319 99.8992 18.842 99.6916 16.3607C99.5221 14.319 99.2057 9.74354 95.7282 9.45144C93.3385 9.25294 90.6786 11.186 88.5146 11.9939C86.6109 12.7025 83.8115 13.66 81.8387 14.026C79.7679 14.4094 78.4549 14.1511 76.5438 15.133C72.4327 17.2423 69.6605 23.2703 69.5797 26.0448C69.5072 28.4851 71.7742 30.7379 73.0677 32.7641Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.836 14.0265C83.8104 13.6601 86.6099 12.7026 88.5136 11.9939C90.6776 11.1861 93.3391 9.2525 95.7271 9.4515C99.2063 9.7431 99.521 14.319 99.6905 16.3608C99.8981 18.8421 99.4304 21.232 100.855 23.3893C102.054 25.2055 103.809 26.7998 103.889 29.033C103.954 30.8126 103.462 32.4823 104.253 34.1253C105.034 35.7449 106.399 37.0964 107.014 38.7863C107.433 39.9404 107.92 41.5105 107.13 42.8237C106.01 44.6891 102.533 44.4273 100.492 44.873C88.6457 47.4639 89.5775 49.3278 85.1016 50.279C81.7055 50.9998 80.983 47.1959 80.8282 45.3244C80.6407 43.0314 80.9933 40.8835 79.7946 38.8408C78.8954 37.3111 78.193 35.9119 78.1293 34.1053C78.0368 31.5104 77.9908 29.1438 76.5639 26.9087C75.2703 24.8825 73.3489 23.0482 73.1153 20.6159C72.9242 18.6201 73.7064 16.4015 76.5411 15.1336C78.5051 14.2549 79.7668 14.4095 81.836 14.0265Z"
        stroke="currentColor"
      />
      <path
        d="M93.0992 16.1035C96.1558 23.6395 82.9394 23.5038 82.6388 30.5932"
        stroke="currentColor"
      />
      <path
        d="M97.5927 26.6539C100.651 34.1911 87.435 34.0554 87.1345 41.1448"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.527 84.1671C85.527 85.9328 82.9435 87.3467 82.5257 88.9766C82.0925 90.6691 83.6611 93.1523 82.8384 94.6383C81.9981 96.1549 79.0557 96.1372 77.8731 97.3705C76.6811 98.6157 76.8204 101.556 75.3474 102.447C73.8851 103.331 71.3582 101.841 69.6834 102.309C68.0594 102.763 66.6738 105.36 64.9105 105.36C63.146 105.36 61.7604 102.763 60.1352 102.309C58.4616 101.841 55.9335 103.33 54.4724 102.446C52.9994 101.556 53.1375 98.6157 51.9466 97.3705C50.764 96.1372 47.8217 96.1537 46.9813 94.6371C46.1587 93.1523 47.7272 90.6691 47.2941 88.9766C46.8763 87.3467 44.2927 85.9328 44.2927 84.1671C44.2927 82.4026 46.8763 80.9887 47.2941 79.3576C47.7272 77.6651 46.1587 75.1831 46.9813 73.6971C47.8217 72.1805 50.764 72.197 51.9466 70.9625C53.1387 69.7185 52.9994 66.7785 54.4724 65.8886C55.9347 65.0046 58.4616 66.4929 60.1364 66.0255C61.7604 65.5723 63.146 62.9758 64.9105 62.9758C66.6738 62.9758 68.0594 65.5723 69.6846 66.0267C71.3582 66.4929 73.8863 65.0046 75.3474 65.8886C76.8204 66.7785 76.6823 69.7197 77.8731 70.9625C79.0557 72.1982 81.9981 72.1805 82.8384 73.6971C83.6611 75.1831 82.0925 77.6651 82.5257 79.3576C82.9435 80.9887 85.527 82.4026 85.527 84.1671Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.0438 72.7413C73.0438 72.7413 62.228 65.8629 53.4576 76.4957C53.4576 76.4957 46.6074 86.3213 54.6343 93.7073C54.6343 93.7073 60.951 99.2143 68.9436 97.4239C68.9436 97.4239 76.666 95.9981 78.7467 89.4242C80.5572 83.7035 80.7142 77.4848 73.0438 72.7413Z"
        stroke="currentColor"
      />
      <path
        d="M65.0168 87.2387C66.3599 86.3405 71.4031 79.4302 67.9603 79.1563C65.8005 78.9864 63.6737 81.5334 60.677 81.4378"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0344 26.6217C45.3938 26.4319 44.7589 26.8229 44.6366 26.8996C44.0996 27.2316 43.5562 27.9129 43.6692 28.7099C43.7929 29.5701 44.5892 29.9459 44.6397 29.9676C45.4142 30.3162 46.4134 30.0618 46.9081 29.4306C47.6632 28.4644 47.0169 26.9118 46.0344 26.6217Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.0943 34.9993C54.2607 34.7378 53.4455 35.2522 53.286 35.3514C52.595 35.7851 51.8982 36.6856 52.057 37.7484C52.2274 38.8944 53.2627 39.4038 53.3288 39.4338C54.3377 39.9072 55.6279 39.5811 56.2611 38.7464C57.2277 37.471 56.3708 35.3991 55.0943 34.9993Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.1086 22.0941C54.5073 22.6865 54.5729 23.6146 54.5854 23.7948C54.6406 24.5806 55.0914 25.5842 56.0695 25.9323C57.1219 26.3085 58.0258 25.6578 58.0833 25.6157C58.9462 24.9721 59.2547 23.7239 58.8315 22.8049C58.1854 21.4019 56.0293 21.189 55.1086 22.0941Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.3238 51.0002C47.5012 50.5108 47.3649 50.3189 46.7505 49.9408C46.2055 49.6079 45.3574 49.0869 44.2852 48.9453C43.5471 48.8477 43.6028 49.0497 42.1795 49.1161C40.7758 49.1818 39.9741 49.2084 39.2373 48.7167C38.733 48.3812 38.4667 47.9405 38.2388 47.5656C37.7166 46.7058 37.863 46.2914 37.2724 45.2494C37.0932 44.9326 36.8876 44.5682 36.5144 44.1891C35.9397 43.6076 35.5619 43.588 34.5608 43.0267C33.4418 42.3987 32.7848 42.0303 32.4439 41.2819C32.1902 40.7248 32.2112 40.177 32.2313 39.6683C32.258 38.957 32.4145 38.8189 32.6058 37.822C32.798 36.8142 32.9122 36.2232 32.7725 35.4973C32.6736 34.9757 32.4406 34.5477 31.9745 33.6904C31.2806 32.4154 31.0978 32.4753 30.8964 31.8248C30.8176 31.5645 30.5033 30.4414 31.0043 29.3884C31.1427 29.0945 31.3515 28.8483 31.7666 28.3571C32.3634 27.6503 32.7088 27.4382 32.9608 26.8665C33.1211 26.5035 33.1656 26.1769 33.1809 25.9738C32.2263 25.8597 31.2602 25.7924 30.2709 25.822C19.3727 26.1416 10.7965 35.2358 11.116 46.1352C11.4357 57.0322 20.531 65.6098 31.4293 65.2889C39.986 65.0374 47.0884 59.3705 49.6015 51.6751C49.2921 51.5317 48.8451 51.3102 48.3238 51.0002Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3017 43.513C17.4419 43.7842 17.0367 44.7085 16.9584 44.8889C16.6145 45.6717 16.5319 46.8543 17.272 47.6707C18.068 48.5494 19.2418 48.3681 19.3163 48.3563C20.4473 48.1615 21.3627 47.1153 21.4288 46.0243C21.5291 44.3597 19.6188 43.0945 18.3017 43.513Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8639 52.3187C29.7398 52.6586 29.2207 53.8484 29.121 54.0783C28.6804 55.0852 28.5872 56.6121 29.5677 57.676C30.6232 58.8198 32.1591 58.6004 32.2571 58.5857C33.7381 58.3493 34.9252 57.0099 34.9969 55.6023C35.1066 53.4538 32.5867 51.7962 30.8639 52.3187Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1336 35.0698C19.9127 36.1816 20.6884 37.1651 20.8383 37.3545C21.495 38.1881 22.7542 38.9617 24.1057 38.6111C25.5613 38.2329 26.0738 36.8247 26.1048 36.7356C26.5772 35.3655 25.9772 33.7449 24.8095 33.0441C23.0303 31.9728 20.4724 33.3661 20.1336 35.0698Z"
        stroke="currentColor"
      />
    </svg>
  );
}
